import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "MixandMatchLazy" */ './MixandMatch'), {
    fallback: null,
});
